/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Code_Edit_WarningInputs */

const vi_warehouse_position_code_edit_warning = /** @type {(inputs: Warehouse_Position_Code_Edit_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi mã sẽ áp dụng cho tất cả lô đang gán vị trí này, kể cả trên phiếu cũ. Nhớ đổi cả nhãn dán trên kệ.`)
};

/**

* @param {Warehouse_Position_Code_Edit_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_code_edit_warning = /** @type {((inputs?: Warehouse_Position_Code_Edit_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Code_Edit_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_code_edit_warning(inputs)
});